import React, { useEffect, useRef, useState, useCallback } from "react";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import moment from "moment-timezone";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { Quill } from "react-quill";

import { FaBan, FaCheckCircle, FaEdit, FaExclamationTriangle, FaExternalLinkAlt, FaMicrophone, FaPen, FaSave, FaStop, FaTrash, FaUsers, FaWrench } from "react-icons/fa";
import { toast } from "react-toastify";
import EditarDescripcionServicioCotizacion from "../dialogs/EditarDescripcionServicioCotizacion";
import EditarPrecioServicioCotizacion from "../dialogs/EditarPrecioServicioCotizacion";
import EditarComentarioVendedorServicioCotizacion from "../dialogs/EditarComentarioVendedorServicioCotizacion";
import ModalInDrawer from "../ui/ModalInDrawer";
import DeleteButton from "../ui/components/DeleteButton";
import IdButton from "../ui/components/IdButton";
import CopyToClipBoard from "../../utils/CopyToClipBoard";
import CalcularPrecioPais from "../../utils/preciosPaises/calcularPrecioPais";
import ObtenerMultiplicador from "../../utils/preciosPaises/obtenerMultiplicador";
import DinamicBoxButton from "../ui/components/DinamicBoxButton";
import ParticipantsModal from "../dialogs/ParticipantsModal";
import ConfirmsModal from "./ConfirmsModal";
// import VariablesServicioModal from "../dialogs/VariablesServicioModal";

const ItemRowServicioCotizacion = ({ data, servicios, planes, tipoCotizacion, setAllServiciosCotizacionesList, allServiciosCotizacionesList, type, pagos, isAdmin, paises, allowUniquePayment }) => {
  
  const [rowValues, setRowValues] = useState({
    pagoUnico: false,
    servicioGratuito: false,
    cotizacion: null,
    estado: "",
    responsable: null,
    subarea: "",
    notas: "",
    servicio: null,
    planServicio: null,
    numeroItems: 0,
    tipoDescuento: null,
    montoDescuento: 0,
    audios: [],
    fechaInicio: {
      startDate: null,
      endDate: null,
    },
    fechaFin: {
      startDate: null,
      endDate: null,
    },
    fechaRenovacion: {
      startDate: null,
      endDate: null,
    },
    fechaLanzamiento: {
      startDate: null,
      endDate: null,
    },
    igv: "no",
    montoigv: 0,
    customDescriptionActive: false,
    customDescriptionText: "",
    comentarioVendedor:"",
    customPriceActive: false,
    customPrice: 0,
    isCuentaPublicitaria: false,
    produccionAudiovisual: false,
    duracionContrato: 0,
    serviceFields: [],
    confirmacionesServicio: null,
  });

  const statusCotizacion = data.cotizacion?.estado;
  const isSelled = statusCotizacion === "Exito";
  const isCalendarioPagos = type === "calendarioPagos";

  const [openEditDescription, setOpenEditDescription] = useState(false);
  const [openEditPrice, setOpenEditPrice] = useState(false);
  const [openEditComentarioVendedor, setOpenEditComentarioVendedor] = useState(false);

  const [isSuccess, setIsSuccess] = useState(false);
  const [processedConfirmaciones, setProcessedConfirmaciones] = useState(null);

  useEffect(() => {
    if (data) {
      if (data.cotizacion) setRowValues((prev) => ({ ...prev, cotizacion: data.cotizacion.id }));
      if (data.participantNumbers) setRowValues((prev) => ({ ...prev, participantNumbers: data.participantNumbers }))
      if (data.participantEmails) setRowValues((prev) => ({ ...prev, participantEmails: data.participantEmails }))
      if (data.serviceFields) setRowValues((prev) => ({ ...prev, serviceFields: data.serviceFields }));
      if (data.pagoUnico) setRowValues((prev) => ({ ...prev, pagoUnico: data.pagoUnico }));
      if (data.servicioGratuito) setRowValues((prev) => ({ ...prev, servicioGratuito: data.servicioGratuito }));
      if (data.estado) setRowValues((prev) => ({ ...prev, estado: data.estado }));
      if (data.responsable) setRowValues((prev) => ({ ...prev, responsable: data.responsable.id }));
      if (data.subarea) setRowValues((prev) => ({ ...prev, subarea: data.subarea }));
      if (data.servicio) setRowValues((prev) => ({ ...prev, servicio: data.servicio.id }));
      if (data.numeroItems) setRowValues((prev) => ({ ...prev, numeroItems: data.numeroItems }));
      if (data.tipoDescuento) setRowValues((prev) => ({ ...prev, tipoDescuento: data.tipoDescuento }));
      if (data.montoDescuento) setRowValues((prev) => ({ ...prev, montoDescuento: data.montoDescuento }));
      if (data.produccionAudiovisual) setRowValues((prev) => ({ ...prev, produccionAudiovisual: data.produccionAudiovisual }));
      if (data.audios) setRowValues((prev) => ({ ...prev, audios: data.audios }))
      if (data.notas) setRowValues((prev) => ({ ...prev, notas: data.notas }))
      if (data.duracionContrato) setRowValues((prev) => ({ ...prev, duracionContrato: data.duracionContrato }))
      if (data.confirmacionesServicio) setRowValues((prev) => ({ ...prev, confirmacionesServicio: data.confirmacionesServicio }))
      if (data.checklistMedia) setRowValues((prev) => ({ ...prev, checklistMedia: data.checklistMedia }))
      if (data.planServicio)
        setRowValues((prev) => ({
          ...prev,
          planServicio: data.planServicio.id,
        }));
      if (data?.isCuentaPublicitaria)
        setRowValues((prev) => ({
          ...prev,
          isCuentaPublicitaria: data.isCuentaPublicitaria,
        }));
      if (data.fechaInicio)
        setRowValues((prev) => ({
          ...prev,
          fechaInicio: {
            startDate: moment.utc(data.fechaInicio).format("YYYY-MM-DD"),
            endDate: moment.utc(data.fechaInicio).format("YYYY-MM-DD"),
          },
        }));
      if (data.fechaFin)
        setRowValues((prev) => ({
          ...prev,
          fechaFin: {
            startDate: moment.utc(data.fechaFin).format("YYYY-MM-DD"),
            endDate: moment.utc(data.fechaFin).format("YYYY-MM-DD"),
          },
        }));
      if (data.fechaRenovacion)
        setRowValues((prev) => ({
          ...prev,
          fechaRenovacion: {
            startDate: moment.utc(data.fechaRenovacion).format("YYYY-MM-DD"),
            endDate: moment.utc(data.fechaRenovacion).format("YYYY-MM-DD"),
          },
        }));
      if (data.fechaLanzamiento)
        setRowValues((prev) => ({
          ...prev,
          fechaLanzamiento: {
            startDate: moment.utc(data.fechaLanzamiento).format("YYYY-MM-DD"),
            endDate: moment.utc(data.fechaLanzamiento).format("YYYY-MM-DD"),
          },
        }));
      if (data.igv)
        setRowValues((prev) => ({
          ...prev,
          igv: data.igv,
        }));
      if (data.montoigv)
        setRowValues((prev) => ({
          ...prev,
          montoigv: data.montoigv?.toFixed(2),
        }));
      if (data?.customDescriptionActive)
        setRowValues((prev) => ({
          ...prev,
          customDescriptionActive: data?.customDescriptionActive,
        }));
      if (data?.customDescriptionText)
        setRowValues((prev) => ({
          ...prev,
          customDescriptionText: data?.customDescriptionText,
        }));
      if (data?.customPriceActive)
        setRowValues((prev) => ({
          ...prev,
          customPriceActive: data?.customPriceActive,
        }));
      if (data?.customPrice)
        setRowValues((prev) => ({
          ...prev,
          customPrice: data?.customPrice,
        }));
        if(data?.comentarioVendedor){
          setRowValues((prev) => ({
            ...prev,
            comentarioVendedor: data?.comentarioVendedor,
          }));
        }else{
          setRowValues((prev) => ({
            ...prev,
            comentarioVendedor: "",
          }));
        }
    }
  }, []);

  // Función genérica para procesar templates de confirmaciones y reemplazar placeholders
  const confirmTemplateProcess = useCallback((template) => {
    if (!template) {
      return "";
    }
    // Si es un array, tomar el primer elemento
    if (Array.isArray(template)) {
      template = template.length > 0 ? template[0] : null;
      if (!template) return "";
    }

    // Preparar datos dinámicos para reemplazo
    const now = new Date();
    const cotizacion = data?.cotizacion || {};
    const cliente = cotizacion?.cliente || {};
    const lead = cotizacion?.lead || {};
    const cotizador = cotizacion?.cotizador || {};

    const nombreServicio = data?.servicio?.name || "N/A";
    const numeroCotizacion = cotizacion?.numeroCotizacion || "N/A";
    const nombreVendedor = cotizador?.name || "N/A";
    const nombreCliente = cliente?.nombreGerente || lead?.leadName || "N/A";
    const dniCliente = cliente?.dni || lead?.leadDNI || "N/A";
    const empresaCliente = cliente?.nombreComercial || lead?.leadCompany || data?.cotizacion?.empresa?.razonSocial || "Monstruo Creativo S.A.C";

    const fecha = format(now, "dd 'de' MMMM 'de' yyyy", { locale: es });
    const hora = format(now, "HH:mm", { locale: es });
    
    // Calcular monto total desde los pagos recibidos como prop
    const montoTotal = (pagos || []).reduce((acc, p) => acc + (p.precio || 0) + ((p.montosServicios?.reduce((acc, ms) => acc + (ms.monto || 0), 0)) || 0), 0).toLocaleString("es-PE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const incluyeIGV = rowValues?.igv === "si" ? "Incluye IGV" : "No incluye IGV";
    const cantidadCuotas = (pagos || []).length > 0 ? pagos.length : 1;

    // Función helper para reemplazar placeholders en un texto
    const replacePlaceholders = (text) => {
      if (!text || typeof text !== "string") return text;
      return text
        .replace(/{nombreServicio}/g, nombreServicio)
        .replace(/{numeroCotizacion}/g, numeroCotizacion)
        .replace(/{nombreVendedor}/g, nombreVendedor)
        .replace(/{nombreCliente}/g, nombreCliente)
        .replace(/{dniCliente}/g, dniCliente)
        .replace(/{empresaCliente}/g, empresaCliente)
        .replace(/{fecha}/g, fecha)
        .replace(/{hora}/g, hora)
        .replace(/{montoTotal}/g, `S/. ${montoTotal}`)
        .replace(/{incluyeIGV}/g, incluyeIGV)
        .replace(/{cantidadCuotas}/g, cantidadCuotas.toString());
    };

    // Caso 1: Es un objeto Delta de Quill (tiene propiedad ops)
    if (template && typeof template === "object" && template.ops && Array.isArray(template.ops) && template.ops.length >= 0) {
      // Clonar el Delta y reemplazar placeholders en los inserts manteniendo el formato
      const processedDelta = {
        ...template,
        ops: template.ops.map((op) => {
          // Si el insert es un string, reemplazar placeholders
          if (typeof op.insert === "string") {
            return {
              ...op,
              insert: replacePlaceholders(op.insert),
            };
          }
          // Si el insert es un objeto (por ejemplo, imágenes, embeds), mantenerlo tal cual
          return op;
        }),
      };
      return processedDelta;
    }

    // Caso 2: Es un string HTML
    if (typeof template === "string") {
      return replacePlaceholders(template);
    }

    // Caso 3: Es un objeto con propiedad html o content
    if (template && typeof template === "object") {
      if (template.html && typeof template.html === "string") {
        return replacePlaceholders(template.html);
      }
      if (template.content && typeof template.content === "string") {
        return replacePlaceholders(template.content);
      }
      // Si es un objeto pero no tiene estructura conocida, intentar stringify y reemplazar
      try {
        const jsonString = JSON.stringify(template);
        const processedJsonString = replacePlaceholders(jsonString);
        // Intentar parsear de vuelta a objeto
        return JSON.parse(processedJsonString);
      } catch (e) {
        console.warn("No se pudo procesar el objeto template:", template);
        return "";
      }
    }

    // Caso 4: Cualquier otro tipo, convertir a string y reemplazar
    return replacePlaceholders(String(template || ""));
  }, [data, pagos, rowValues?.igv]);

  // Función para procesar las confirmaciones y reemplazar placeholders
  const processConfirmaciones = useCallback(() => {
    // Usar confirmacionesServicio directamente del servicio cotización
    const confirmacionesTemplate = rowValues.confirmacionesServicio || data?.confirmacionesServicio;
    if (!confirmacionesTemplate) return "";
    // Si es un array, tomar el primer elemento (caso del estado inicial)
    const template = Array.isArray(confirmacionesTemplate) ? confirmacionesTemplate[0] : confirmacionesTemplate;
    if (!template) return "";
    return confirmTemplateProcess(template);
  }, [data, rowValues.confirmacionesServicio, confirmTemplateProcess]);

  // Actualizar confirmaciones cuando cambie el plan o servicio (se copian automáticamente desde el backend)
  useEffect(() => {
    if (data?.confirmacionesServicio) {
      setRowValues((prev) => ({ ...prev, confirmacionesServicio: data.confirmacionesServicio }));
    }
  }, [data?.confirmacionesServicio]);

  // Actualizar confirmaciones cuando cambie el plan seleccionado (antes de guardar)
  // Solo actualizar si el plan cambió manualmente (diferente del plan en data)
  useEffect(() => {
    if (rowValues.servicio && rowValues.planServicio && servicios.length > 0) {
      const planIdFromData = data?.planServicio?.id || data?.planServicio;
      const planIdFromRowValues = rowValues.planServicio;
      
      // Solo actualizar si el plan cambió manualmente (diferente del plan inicial)
      if (planIdFromData !== planIdFromRowValues) {
        const servicioSeleccionado = servicios.find((serv) => serv.id === rowValues.servicio);
        if (servicioSeleccionado?.preciosUnitarios) {
          const precioUnitario = servicioSeleccionado.preciosUnitarios.find(
            (precio) => {
              const precioPlanId = typeof precio.plan === 'object' ? precio.plan?.id : precio.plan;
              return precioPlanId === planIdFromRowValues;
            }
          );
          if (precioUnitario?.confirmaciones) {
            setRowValues((prev) => ({ 
              ...prev, 
              confirmacionesServicio: precioUnitario.confirmaciones 
            }));
          }
        }
      }
    }
  }, [rowValues.planServicio, rowValues.servicio, servicios, data?.planServicio]);

  // Procesar confirmaciones cuando cambien los datos o pagos
  useEffect(() => {
    if (data) {
      const processed = processConfirmaciones();
      setProcessedConfirmaciones(processed || "");
    }
  }, [data, pagos, rowValues, processConfirmaciones]);

  // Función para normalizar confirmacionesServicio a formato Delta antes de enviar al backend
  const normalizeConfirmacionesToDelta = useCallback((content) => {
    if (!content) {
      return null;
    }

    // Si ya es un objeto Delta con ops, retornarlo directamente
    if (typeof content === "object" && content.ops && Array.isArray(content.ops)) {
      return content;
    }

    // Si es un string HTML, convertirlo a Delta usando Quill
    if (typeof content === "string") {
      try {
        const Delta = Quill.import('delta');
        const tempQuill = new Quill(document.createElement('div'));
        tempQuill.clipboard.dangerouslyPasteHTML(content);
        return tempQuill.getContents();
      } catch (e) {
        console.warn("Error convirtiendo HTML a Delta:", e);
        const Delta = Quill.import('delta');
        return new Delta().insert(content + '\n');
      }
    }

    // Si es un array, tomar el primer elemento y normalizarlo
    if (Array.isArray(content) && content.length > 0) {
      return normalizeConfirmacionesToDelta(content[0]);
    }

    // Si es otro tipo de objeto, intentar convertirlo
    try {
      const Delta = Quill.import('delta');
      return new Delta().insert(JSON.stringify(content) + '\n');
    } catch (e) {
      console.warn("Error normalizando contenido a Delta:", e);
      return null;
    }
  }, []);

  const saveItem = async () => {
    try {
      let audiosIds = [];
  
      // Filtrar audios que no tienen la propiedad `id`
      const audiosToUpload = rowValues.audios?.filter((file) => !file.id);
  
      if (audiosToUpload.length > 0) {
        for (const file of audiosToUpload) {
          const audioId = await uploadAudio(file);
          audiosIds.push(audioId);
        }
      }

      // Obtener los IDs de los audios que ya existen
      const existingAudioIds = rowValues.audios
      .filter((file) => file.id)
      .map((file) => file.id);

      // Combinar los IDs de los audios existentes con los nuevos
      audiosIds = [...existingAudioIds, ...audiosIds];
  
      const formattedData = {
        servicio: rowValues.servicio,
        planServicio: rowValues.planServicio,
        numeroItems: rowValues.numeroItems,
        participantNumbers: rowValues.participantNumbers,
        participantEmails: rowValues.participantEmails,
        servicioGratuito: rowValues.servicioGratuito,
        produccionAudiovisual: rowValues.produccionAudiovisual,
        fechaInicio: moment
          .utc(rowValues.fechaInicio.startDate)
          .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
        fechaFin: rowValues.fechaFin.startDate,
        montoigv: rowValues.montoigv,
        igv: rowValues.igv,
        audios: audiosIds,
        notas: rowValues.notas,
        fechaRenovacion: rowValues.fechaRenovacion.startDate,
        fechaLanzamiento: rowValues.fechaLanzamiento.startDate,
        customDescriptionActive: rowValues.customDescriptionActive,
        customDescriptionText: rowValues.customDescriptionText,
        customPriceActive: rowValues.customPriceActive,
        customPrice: rowValues.customPrice,
        pagoUnico: rowValues.pagoUnico,
        isCuentaPublicitaria: rowValues.isCuentaPublicitaria,
        comentarioVendedor: rowValues.comentarioVendedor,
        tipoDescuento: rowValues.tipoDescuento,
        montoDescuento: rowValues.montoDescuento,
        duracionContrato: rowValues.duracionContrato,
        confirmacionesServicio: normalizeConfirmacionesToDelta(rowValues.confirmacionesServicio)
      };

      console.log(formattedData)
  
      const response = await axios.put(
        `${BACKEND}/api/serviciosCotizaciones/${data.id}`,
        formattedData
      );
  
      const updatedService = response.data.doc;
      updateCotizacionLocally(updatedService);
      
      // Actualizar confirmacionesServicio con las confirmaciones actualizadas del backend
      // (el backend las actualiza automáticamente cuando cambia el plan)
      if (updatedService.confirmacionesServicio !== undefined) {
        setRowValues((prev) => ({ 
          ...prev, 
          confirmacionesServicio: updatedService.confirmacionesServicio 
        }));
      }
      
      setIsSuccess(true);
      setTimeout(() => setIsSuccess(false), 2000);
    } catch (e) {
      console.log(e)
      toast.error("Error al guardar el servicio: " + e)
    }
  };
  
  const updateCotizacionLocally = (updatedCot) => {
    setAllServiciosCotizacionesList((prevCotList) => {
      return prevCotList.map((cot) => {
        if (cot.id === updatedCot.id) {
          return { ...cot, ...updatedCot };
        } else {
          return cot;
        }
      });
    });
  };

  const deleteItem = async () => {
    if (!window.confirm("¿Estás seguro de que quieres eliminar este servicio?")) return;

    await axios
      .delete(`${BACKEND}/api/serviciosCotizaciones/${data.id}`)
      .then(({ data }) => {
        const filteredArray = allServiciosCotizacionesList.filter(
          (ev) => ev.id !== data.id
        );
        setAllServiciosCotizacionesList(filteredArray);
      })
      .then(() =>
        toast.success("Servicio eliminado correctamente")
      )
      .catch(() =>
        toast.error("Error al eliminar el servicio")
      );
  };

  // Busca el servicio que contiene el plan coincidente
  const descriptionSelectedPlan = data.servicio.preciosUnitarios.find(
    (precioUnitario) => precioUnitario.plan && precioUnitario.plan.name === data.planServicio.name
  );

  const defaultDescription = descriptionSelectedPlan
  ? descriptionSelectedPlan.descripcion
  : "Plan no encontrado, ingresa manualmente la info :)";

    // Audios

  const [modalStatus, setModalStatus] = useState(false)
  
  const [isRecording, setIsRecording] = useState(false)

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const uploadAudio = async (file) => { // Subir audio
    try {
      const formData = new FormData()

      formData.append("file", file)

      const response = await axios.post(`${BACKEND}/api/audiosServicios`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })

      return response.data.doc.id

    } catch (error) {
      toast.error("Error subiendo el audio")
    }
  }

  const generateFileName = () => { // Generar nombre del audio
    return `audio_${new Date().getTime()}.wav`;
  };
  
  const startRecording = () => { // Empezar a grabar
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          const mediaRecorder = new MediaRecorder(stream);
          mediaRecorderRef.current = mediaRecorder;
          mediaRecorder.start();
    
          setIsRecording(true);  // Cambia el estado para indicar que está grabando
  
          mediaRecorder.ondataavailable = (event) => {
              audioChunksRef.current.push(event.data);
          };
    
          mediaRecorder.onstop = async () => {
            const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
            const fileName = generateFileName();
              
            const audioFile = new File([audioBlob], fileName, { type: 'audio/wav' });
            const audioUrl = URL.createObjectURL(audioBlob);
            setIsRecording(false);
  
            if (audioFile.size <= 5000000 && rowValues.audios.length < 5) {
              setRowValues(prevValues => ({
                ...prevValues,
                audios: [...prevValues.audios, audioFile]
              }))

            } else {
              toast.warning('El archivo de audio excede el tamaño máximo de 5MB o se alcanzó el límite de 5 archivos.');
            }
  
            audioChunksRef.current = [];
          };
        })
        .catch((error) => {
          toast.error('Error: ' + error);
        });
    } else {
      toast.error('Tu navegador no soporta la grabación de audio.');
    }
  };

  const stopRecording = () => { // Detener la graación
    if (mediaRecorderRef.current) {
        mediaRecorderRef.current.stop();  // Detiene la grabación
        setIsRecording(false);  // Cambia el estado para indicar que se dejó de grabar
    }
  };

  const deleteAudio = (indexToDelete) => { // Eliminar un audio
    setRowValues((prevValues) => ({
      ...prevValues,
      audios: prevValues.audios.filter((_, index) => index !== indexToDelete)
    }))
  }

  // Variables del servicio
  const [serviceVariablesModal, setServiceVariablesModal] = useState(false)

  // Confirmaciones
  const [advicesModalStatus, setAdvicesModalStatus] = useState(false)

  // Speech
  const [sellOpsModalStatus, setSellOpsModalStatus] = useState(false)

  return (
    <>
      <EditarDescripcionServicioCotizacion
        open={openEditDescription}
        onClose={() => setOpenEditDescription(false)}
        description={rowValues.customDescriptionText}
        //customizedDescriptions={data.servicio.customizedDescriptions}
        defaultDescription={defaultDescription}
        setDescripcion={(e) =>
          setRowValues((prev) => ({ ...prev, customDescriptionText: e }))
        }
      />

      <EditarPrecioServicioCotizacion
        open={openEditPrice}
        onClose={() => setOpenEditPrice(false)}
        price={rowValues.customPrice}
        setPrice={(e) => setRowValues((prev) => ({ ...prev, customPrice: e }))}
      />

      <EditarComentarioVendedorServicioCotizacion
        onClose={()=>setOpenEditComentarioVendedor(false)}
        open={openEditComentarioVendedor}
        comentarioVendedor={rowValues.comentarioVendedor}
        setComentarioVendedor={(e) => setRowValues((prev) => ({ ...prev, comentarioVendedor : e }))}
      />

      <ModalInDrawer
        activeModal={modalStatus}
        onClose={() => setModalStatus(false)}
        title="Audios del servicio"
        centered
      >
        <div className="flex flex-col gap-6 text-xs">

          <div className="audios border border-gray-300 rounded-md p-4">
            <label className="block text-gray-700 mb-4" htmlFor="audiosAdmin">
              Audios
            </label>
            <div className="flex flex-col w-full">

              {rowValues.audios?.length > 0 ? (
                <ul className="list-disc">
                  {rowValues.audios.map((fileObj, index) => {
                    const url = fileObj.url ? fileObj.url : URL.createObjectURL(fileObj)
                    const type = fileObj.mimeType ? fileObj.mimeType : fileObj.type
                    const name = fileObj.filename ? fileObj.filename : fileObj.name

                    const fileType = type.split('/')[0];
                    const mimeType = type
                    
                    return (
                      <div key={index} className="mb-8 px-4">

                        {fileType === 'audio' && (
                          <div className="space-y-4 bg-gray-50 border border-gray-200 rounded-md p-4 shadow-sm">
                            <div className="flex items-center justify-between border-b border-gray-200 pb-2 mb-2">
                              <span className="font-semibold text-gray-800">{name}</span>
                              <div className="flex space-x-2">
                                <button
                                  type="button"
                                  onClick={() => window.open(url, '_blank')}
                                  className="p-2 text-blue-500 hover:bg-blue-600 hover:bg-opacity-20 rounded-md transition duration-150"
                                  title="Abrir en una nueva pestaña"
                                >
                                  <FaExternalLinkAlt />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => deleteAudio(index)}
                                  className="p-2 text-red-500 hover:bg-red-600 hover:bg-opacity-20 rounded-md transition duration-150"
                                  title="Eliminar audio"
                                >
                                  <FaTrash />
                                </button>
                              </div>
                            </div>
                            <audio controls className="w-full rounded-md bg-gray-100">
                              <source src={url} type={mimeType || 'audio/mpeg'} />
                              Tu navegador no soporta el elemento de audio.
                            </audio>
                          </div>
                        
                        )}

                      </div>
                    );
                  })}
                </ul>
              ) : (
                <div className="flex justify-center items-center h-[50px] border rounded-md mb-4">
                  No hay archivos subidos
                </div>
              )}

            </div>

            <div className="newLinks">
              {rowValues.audios?.length < 5 ? (
                !isRecording ? (
                  <button
                    onClick={startRecording}
                    className="flex w-full justify-center items-center gap-2 bg-white hover:bg-green-200 transition-all duration-100 text-white px-4 py-2 rounded-lg"
                  >
                    <span className="text-green-700">Grabar nuevo audio</span>
                    <FaMicrophone className="text-green-700"/>
                  </button>
                ) : (
                  <button
                    onClick={stopRecording}
                    className="flex w-full justify-center items-center gap-2 bg-white hover:bg-red-200 transition-all duration-100 text-white px-4 py-2 rounded-lg"
                  >
                    <span className="text-red-700">Detener grabación</span>
                    <FaStop className="text-red-700"/>
                  </button>
                )

              ) : (
                <div className="flex w-full justify-center items-center">
                  Ya has subido el máximo de 5 audios
                </div>
              )
            }
            </div>

          </div>
        </div>
      </ModalInDrawer>

      <ConfirmsModal
        activeModal={advicesModalStatus}
        onClose={() => setAdvicesModalStatus(false)}
        confirmacionesServicio={rowValues.confirmacionesServicio || data?.confirmacionesServicio}
        setConfirmacionesServicio={(value) => 
          setRowValues((prev) => ({ ...prev, confirmacionesServicio: value }))
        }
        processedConfirmaciones={processedConfirmaciones}
        data={data}
        pagos={pagos}
        rowValues={rowValues}
        readOnly={false}
        onSave={(value) => {
          setRowValues((prev) => ({ ...prev, confirmacionesServicio: value }));
        }}
      />

      <ParticipantsModal
        activeModal={sellOpsModalStatus}
        onClose={() => setSellOpsModalStatus(false)}
        data={data}
        rowValues={rowValues}
        serviceId={data?.id}
        setRowValues={setRowValues}
        updateCotizacionLocally={updateCotizacionLocally}
      />

      {/* Valores de la fila */}
      <tr className="bg-white border-b text-xs">
        
        {/* Eliminar */}
        {type !== "calendarioPagos" && (
          isAdmin && (
            <th scope="row" className="px-6 py-4">
              <DeleteButton 
                action={deleteItem}
                content={"Eliminar servicio"}
              />
            </th>
          )
        )}

        {/* Guardar */}
        {type !== "calendarioPagos" && (
          <td className="px-6 py-4 sticky z-20 left-0 bg-white min-w-[60px] w-[60px]">
            <div className=" flex justify-start items-center gap-2">
              {isSuccess ? (
                <DinamicBoxButton
                  content="Guardar"
                  disabled={true}
                  icon={<FaCheckCircle className="text-[10px]" />}
                  color="green"
                />
              ) : (
                <DinamicBoxButton
                  action={saveItem}
                  content="Guardar"
                  icon={<FaSave className="text-[10px]" />}
                  color="blue"
                />
              )}
            </div>
          </td>
        )}

        {/* ID */}
        <th
          scope="row"
          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
        >
          <IdButton
            content={data.id}
            action={() => CopyToClipBoard(data.id)}
          />
        </th>
        
        {/* Requiere prod. audiovisual */}
        {data?.cotizacion?.estado === "Exito" && (
          <td className="px-6 py-4">
            <div className="flex justify-center items-center">
              <label className="relative inline-flex mt-1 items-center cursor-pointer">
                <input
                  id={"produccionAudiovisual"}
                  type="checkbox"
                  disabled={isSelled && !isAdmin}
                  checked={!!rowValues.produccionAudiovisual}
                  onChange={(e) =>
                    setRowValues((prev) => ({
                      ...prev,
                      produccionAudiovisual: e.target.checked,
                    }))
                  }
                  className="sr-only peer"
                />{" "}
                <div className="w-11 h-6 my-auto bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all peer-checked:bg-blue-600"></div>
              </label>
            </div>
          </td>
        )}

        {/* Confirmaciones */}
        <th
          scope="row"
          className={`px-6 py-4 bg-white ${
            isCalendarioPagos
              ? ""
              : "sticky z-20 left-[60px] min-w-[60px] w-[60px] max-w-[60px]"
          } font-medium text-gray-900 text-center whitespace-nowrap`}
        >
          <div className="flex justify-center items-center">
            {data.servicio.needConfirmations ? (
              <DinamicBoxButton
                content={"Confirmaciones"}
                action={() => setAdvicesModalStatus(true)}
                icon={<FaExclamationTriangle className="text-[10px]" />}
                color="yellow"
              />
            ) : (
              <DinamicBoxButton
                content={"Las confirmaciones están deshabilitadas para este servicio"}
                icon={<FaBan className="text-[10px]" />}
                color="gray"
              />
            )}

          </div>
        </th>

        {/* Operaciones de venta */}
        <th
          scope="row"
          className={`px-6 py-4 bg-white ${
            isCalendarioPagos
              ? ""
              : "sticky z-20 left-[120px] min-w-[60px] w-[60px] max-w-[60px]"
          } font-medium text-gray-900 text-center whitespace-nowrap`}
        >
          <div className="flex justify-center items-center">
            <DinamicBoxButton
              content={data?.cotizacion?.estado === "Exito" ? "Operaciones de venta" : "Solo se pueden generar drive y grupos de WhatsApp en cotizaciones en éxito"}
              action={() => setSellOpsModalStatus(true)}
              icon={<FaWrench className="text-xs" />}
              color="blue"
              disabled={data?.cotizacion?.estado !== "Exito"}
            />
          </div>
        </th>

        {/* Editar descripción */}
        <td
          className={`px-6 py-4 bg-white min-w-[100px] whitespace-nowrap ${
            isCalendarioPagos ? "" : "sticky z-20 left-[180px]"
          }`}
        >
          <div className=" flex justify-start gap-4  items-start ">
            <label className="relative inline-flex  mt-1  items-center cursor-pointer">
              <input
                id={"customDescripcion"}
                type="checkbox"
                disabled={isSelled && !isAdmin}
                value={rowValues.customDescriptionActive}
                checked={rowValues.customDescriptionActive}
                onChange={(e) =>
                  setRowValues((prev) => ({
                    ...prev,
                    customDescriptionActive: !rowValues.customDescriptionActive,
                  }))
                }
                className="sr-only peer"
              />{" "}
              <div className="w-11 h-6  my-auto bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300  rounded-full peer  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all  peer-checked:bg-blue-600"></div>
            </label>

            {rowValues.customDescriptionActive && (
              <button
                type="button"
                onClick={() => setOpenEditDescription(true)}
                className="p-2 rounded-md bg-gray-50 border-gray-200 border hover:bg-gray-200   "
              >
                <FaEdit />
              </button>
            )}
          </div>
        </td>

        {/* Cuenta comercial o publicitaria */}
        <th
          scope="row "
          className="px-6 py-4 z-10 font-medium text-gray-900 whitespace-nowrap"
        >
          {data.servicio?.cuentaComercialPublicitariaActive ? <label className="relative inline-flex  mt-1  items-center cursor-pointer">
            <input
              id={"isCuentaPublicitaria"}
              type="checkbox"
              disabled={isSelled}
              value={rowValues.isCuentaPublicitaria}
              checked={rowValues.isCuentaPublicitaria}
              onChange={(e) =>
                setRowValues((prev) => ({
                  ...prev,
                  isCuentaPublicitaria: !rowValues.isCuentaPublicitaria,
                }))
              }
              className="sr-only peer"
            />{" "}
            <div 
              className="w-11 h-6  my-auto bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300  rounded-full peer 
              peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] 
              after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all  
              peer-checked:bg-blue-600">
            </div>
            <span className="ms-3 text-xs font-medium text-gray-900 ">
              {rowValues.isCuentaPublicitaria
                ? "Cuenta cliente"
                : "Cuenta agencia"}
            </span>
          </label> : "No aplica"}
        </th>
        
        {/* Servicio */}
        <td
          className={`px-6 py-4 bg-white min-w-[240px] ${
            isCalendarioPagos ? "" : "sticky z-20 left-[280px]"
          }`}
        >
          <select
            value={rowValues.servicio || "Selecciona una opción"}
            disabled={isSelled && !isAdmin}
            onChange={(e) =>
              setRowValues((prev) => ({ ...prev, servicio: e.target.value }))
            }
            className="bg-gray-50 text-xs border max-w-[10rem] border-gray-300 hover:cursor-pointer text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-1.5"
          >
            <option defaultValue value="Selecciona una opción">Selecciona una opción</option>

            {servicios
              .filter((e) => e.active !== false || e.id === rowValues.servicio)
              .map((e) => (
              <option key={e.id} value={e.id}>
                {e.name}
              </option>
            ))}
          </select>
        </td>
        
        {/* Plan */}
        <td className="px-6 py-4">
          <select
            value={rowValues.planServicio || "Selecciona una opción"}
            disabled={isSelled && !isAdmin}
            onChange={(e) =>
              setRowValues((prev) => ({
                ...prev,
                planServicio: e.target.value,
              }))
            }
            className="bg-gray-50 border border-gray-300 w-[100px] text-gray-900 hover:cursor-pointer text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-1.5"
          >
            <option defaultValue value="Selecciona una opción">Selecciona una opción</option>

            {rowValues.servicio && servicios.length>0 && servicios.find((serv)=>serv.id===rowValues.servicio).preciosUnitarios.map((e) => (
              <option key={e.id} value={e.plan.id}>
                {e.plan.name}
              </option>
            ))}
          </select>
        </td>
        
        {/* Comentario vendedor */}
        <td className="px-6 py-4">
          <div className="flex justify-start gap-4 items-start">
            <button
              type="button"
              disabled={isSelled && !isAdmin}
              onClick={() => setOpenEditComentarioVendedor(true)}
              className="p-2 rounded-md bg-gray-50 transition-all duration-100 border-gray-200 border hover:bg-gray-200 "
            >
              <FaEdit />
            </button>
          </div>
        </td>
        
        {/* Audios */}
        <td className=" px-6 py-4">
          <button
            // disabled={isSelled && !isAdmin}
            onClick={() => setModalStatus(true)}
            className="flex justify-center p-2 rounded-md bg-green-50"
          >
            <FaMicrophone className="text-green-600" />
          </button>
        </td>
        
        {/* Cantidad/meses  */}
        <td className="px-6 py-4">
          <input
            value={rowValues.numeroItems}
            disabled={isSelled && !isAdmin}
            onChange={(e) =>
              setRowValues((prev) => ({
                ...prev,
                numeroItems: Number(e.target.value),
              }))
            }
            className="bg-gray-50 border border-gray-300 w-[50px] text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 p-1.5 max-w-xs"
          />
        </td>
        
        {/* Precio unitario */}
        <td className="px-6 py-4">
          {rowValues.customPriceActive
            ? rowValues.customPrice
            : rowValues.servicio &&
              rowValues.planServicio &&
              CalcularPrecioPais({precio: servicios
                .find((e) => e.id === rowValues.servicio)
                .preciosUnitarios.find(
                  (ev2) => ev2.plan.id === rowValues.planServicio
                )?.precio,
                multiplicador: ObtenerMultiplicador({pais: data?.cotizacion?.cliente?.pais || data?.cotizacion?.lead?.country, paises: paises})
              })?.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          }
        </td>

        {/* Editar precio unitario */}
        <td className="px-6 py-4">
          <div className=" flex justify-start gap-4 items-start">
            <label className="relative inline-flex mt-1 items-center cursor-pointer">
              <input
                id={"customPrice"}
                type="checkbox"
                disabled={isSelled && !isAdmin}
                value={rowValues.customPriceActive}
                checked={rowValues.customPriceActive}
                onChange={(e) =>
                  setRowValues((prev) => ({
                    ...prev,
                    customPriceActive: !rowValues.customPriceActive,
                    customPrice: 0
                  }))
                }
                className="sr-only peer"
              />{" "}
              <div className="w-11 h-6 my-auto bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all  peer-checked:bg-blue-600"></div>
            </label>

            {rowValues.customPriceActive && (
              <button
                type="button"
                onClick={() => setOpenEditPrice(true)}
                className="p-2 rounded-md bg-gray-50 border-gray-200 border hover:bg-gray-200   "
              >
                <FaEdit />
              </button>
            )}
          </div>
        </td>
      
        {/* Tipo descuento unitario */}
        <td className="px-6 py-4">
          <select
            value={rowValues.tipoDescuento || "Sin descuento"}
            disabled={isSelled && !isAdmin}
            onChange={(e) =>{
              setRowValues((prev) => ({
                ...prev,
                tipoDescuento: e.target.value,
              }))
              if (e.target.value === "Sin descuento") {
                setRowValues((prev) => ({
                  ...prev,
                  montoDescuento: 0,
                }))
              }
            }
            }
            className="bg-gray-50 border border-gray-300 w-[100px] text-gray-900 hover:cursor-pointer text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-1.5"
          >
            <option defaultValue value="Sin descuento">Sin descuento</option>
            <option value="Fijo">Fijo</option>
            <option value="Porcentaje">Porcentaje</option>
            {/* <option value="Cupon">Cupón</option> */}
          </select>
        </td> 

        {/* Monto descuento unitario*/}
        <td className="px-6 py-4 flex flex-row gap-2 items-center justify-center">
          <input
            value={rowValues.montoDescuento}
            disabled={isSelled && !isAdmin}
            onChange={(e) =>
              setRowValues((prev) => ({
                ...prev,
                montoDescuento: e.target.value,
              }))
            }
            className="bg-gray-50 border border-gray-300 w-[50px] text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 p-1.5 max-w-xs"
          />
          <span className="text-xs">
            {
              rowValues.tipoDescuento === "Fijo" ? "PEN" : 
              rowValues.tipoDescuento === "Porcentaje" ? "%" : 
              (rowValues.tipoDescuento === "Sin descuento" || rowValues.tipoDescuento === undefined) ? "" : null
            }
          </span>

        </td> 
        
        {/* Subtotal unitario */}
        <td className="px-6 py-4">
          {(() => {
            // Obtener precio unitario base con multiplicador por país
            const precioUnitario = rowValues.customPriceActive
              ? rowValues.customPrice
              : rowValues.servicio &&
                rowValues.planServicio &&
                CalcularPrecioPais({
                  precio: servicios
                    .find((e) => e.id === rowValues.servicio)
                    .preciosUnitarios.find(
                      (ev2) => ev2.plan.id === rowValues.planServicio
                    )?.precio || 0,
                  multiplicador: ObtenerMultiplicador({
                    pais: data?.cotizacion?.cliente?.pais || data?.cotizacion?.lead?.country,
                    paises: paises
                  })
                });

            // Calcular descuento unitario
            let descuentoUnitario = 0;
            if (rowValues.tipoDescuento === "Porcentaje") {
              descuentoUnitario = precioUnitario * (rowValues.montoDescuento / 100);
            } else if (rowValues.tipoDescuento === "Fijo") {
              descuentoUnitario = rowValues.montoDescuento;
            }

            // Retornar precio unitario con descuento
            return (precioUnitario - descuentoUnitario)?.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          })()}
        </td>

        {/* Subtotal */}
        <td className="px-6 py-4">
          {(() => {
            // Obtener precio unitario base con multiplicador por país
            const precioUnitario = rowValues.customPriceActive
              ? rowValues.customPrice
              : rowValues.servicio &&
                rowValues.planServicio &&
                CalcularPrecioPais({
                  precio: servicios
                    .find((e) => e.id === rowValues.servicio)
                    .preciosUnitarios.find(
                      (ev2) => ev2.plan.id === rowValues.planServicio
                    )?.precio || 0,
                  multiplicador: ObtenerMultiplicador({
                    pais: data?.cotizacion?.cliente?.pais || data?.cotizacion?.lead?.country,
                    paises: paises
                  })
                });

            // Calcular descuento unitario
            let descuentoUnitario = 0;
            if (rowValues.tipoDescuento === "Porcentaje") {
              descuentoUnitario = precioUnitario * (rowValues.montoDescuento / 100);
            } else if (rowValues.tipoDescuento === "Fijo") {
              descuentoUnitario = rowValues.montoDescuento;
            }

            // Calcular precio unitario con descuento
            const precioUnitarioConDescuento = precioUnitario - descuentoUnitario;

            // Retornar subtotal (precio unitario con descuento * cantidad)
            return (precioUnitarioConDescuento * rowValues.numeroItems)?.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          })()}
        </td>

        {/* IGV */}
        <td className="px-6 py-4">
          <label className="relative inline-flex items-center mt-1 cursor-pointer">
            <input
              id={"igv"}
              type="checkbox"
              value={rowValues.igv}
              checked={rowValues.igv === "si"}
              disabled={isSelled && !isAdmin}
              onChange={(e) => {
                const newIgvValue = rowValues.igv === "no" ? "si" : "no";
                
                // Calcular precio base unitario
                const precioBase = rowValues.customPriceActive
                  ? rowValues.customPrice
                  : rowValues.servicio && rowValues.planServicio
                    ? servicios
                        .find((e) => e.id === rowValues.servicio)
                        ?.preciosUnitarios.find(
                          (ev2) => ev2.plan.id === rowValues.planServicio
                        )?.precio || 0
                    : 0;

                // Calcular descuento unitario
                let montoDescuento = 0;
                if (rowValues.tipoDescuento === "Porcentaje") {
                  montoDescuento = precioBase * (rowValues.montoDescuento / 100);
                } else if (rowValues.tipoDescuento === "Fijo") {
                  montoDescuento = rowValues.montoDescuento;
                }

                // Calcular subtotal unitario
                const subtotalUnitario = precioBase - montoDescuento;

                // Calcular IGV total
                const igvTotal = newIgvValue === "si" ? subtotalUnitario * 0.18 * rowValues.numeroItems : 0;

                // Actualizar los valores en el estado
                setRowValues((prev) => ({
                  ...prev,
                  igv: newIgvValue,
                  montoigv: igvTotal.toFixed(2)
                }));
              }}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all peer-checked:bg-blue-600"></div>
          </label>
        </td>

        {/* Monto IGV unitario */}
        <td className="px-6 py-4">
          {(() => {
            // Calcular precio base unitario
            const precioBase = rowValues.customPriceActive
              ? rowValues.customPrice
              : rowValues.servicio && rowValues.planServicio
                ? servicios
                    .find((e) => e.id === rowValues.servicio)
                    ?.preciosUnitarios.find(
                      (ev2) => ev2.plan.id === rowValues.planServicio
                    )?.precio || 0
                : 0;

            // Calcular descuento unitario
            let montoDescuento = 0;
            if (rowValues.tipoDescuento === "Porcentaje") {
              montoDescuento = precioBase * (rowValues.montoDescuento / 100);
            } else if (rowValues.tipoDescuento === "Fijo") {
              montoDescuento = rowValues.montoDescuento;
            }

            // Calcular subtotal unitario
            const subtotalUnitario = precioBase - montoDescuento;

            // Calcular IGV unitario
            const igvUnitario = rowValues.igv === "si" ? subtotalUnitario * 0.18 : 0;

            return igvUnitario?.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          })()}
        </td> 

        {/* Monto IGV total*/}
        <td className="px-6 py-4">
          {(() => {
            // Calcular precio base unitario
            const precioBase = rowValues.customPriceActive
              ? rowValues.customPrice
              : rowValues.servicio && rowValues.planServicio
                ? servicios
                    .find((e) => e.id === rowValues.servicio)
                    ?.preciosUnitarios.find(
                      (ev2) => ev2.plan.id === rowValues.planServicio
                    )?.precio || 0
                : 0;

            // Calcular descuento unitario
            let montoDescuento = 0;
            if (rowValues.tipoDescuento === "Porcentaje") {
              montoDescuento = precioBase * (rowValues.montoDescuento / 100);
            } else if (rowValues.tipoDescuento === "Fijo") {
              montoDescuento = rowValues.montoDescuento;
            }

            // Calcular subtotal unitario
            const subtotalUnitario = precioBase - montoDescuento;

            // Calcular IGV total (unitario * cantidad)
            const igvTotal = rowValues.igv === "si" ? subtotalUnitario * 0.18 * rowValues.numeroItems : 0;

            return igvTotal?.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          })()}
        </td> 
        
        {/* Pago único */}
        {allowUniquePayment && (
          <td className=" px-6 py-4">
            <input
              type="checkbox"
              disabled={isSelled && !isAdmin}
              checked={rowValues.pagoUnico}
              onChange={(e) => {
                setRowValues((prev) => ({
                  ...prev,
                  pagoUnico: e.target.checked
                }));
              }}
              //disabled={!isAdmin}
              className="flex justify-center p-2 rounded-md bg-green-50"
            />
          </td>
        )}

        {/* Servicio gratuito */}
        <td className=" px-6 py-4">
          <input
            type="checkbox"
            disabled={isSelled && !isAdmin}
            checked={rowValues.servicioGratuito}
            onChange={(e) => {
              setRowValues((prev) => ({
                ...prev,
                servicioGratuito: e.target.checked
              }));
            }}
            className="flex justify-center p-2 rounded-md bg-green-50"
          />
        </td>

        {/* Fecha tentativa inicio */}
        <td className="px-6 py-4 z-10">
          <input 
            type="date"
            placeholder="Fecha de inicio"
            value={rowValues.fechaInicio?.startDate || ''} // Manejo de valores nulos/undefined
            disabled={isSelled && !isAdmin}
            className="py-2 px-4 border border-gray-300 focus:outline-none rounded-md text-xs"
            onChange={(e) => 
              setRowValues((prev) => ({
                ...prev,
                fechaInicio: {
                  ...prev.fechaInicio, // Mantener otros valores dentro de fechaInicio
                  startDate: e.target.value, // Actualizar startDate
                  endDate: e.target.value,   // Sincronizar endDate
                },
              }))
            }
          />
        </td>
        
        {/* Fecha tentativa fin */}
        <td className="px-6 py-4">
          <input 
            type="date"
            placeholder="Fecha de fin"
            value={rowValues.fechaFin?.startDate || ''} // Manejo de valores nulos/undefined
            disabled={isSelled && !isAdmin}
            className="py-2 px-4 border border-gray-300 focus:outline-none rounded-md text-xs"
            onChange={(e) => 
              setRowValues((prev) => ({
                ...prev,
                fechaFin: {
                  ...prev.fechaFin, // Mantener otros valores dentro de fechaInicio
                  startDate: e.target.value, // Actualizar startDate
                  endDate: e.target.value,   // Sincronizar endDate
                },
              }))
            }
          />
        </td>

        {/* Precio venta unitario */}
        <td className="px-6 py-4 sticky z-20 right-0 bg-white whitespace-nowrap">
          <span className="text-xs">
          {(() => {
              // 1. Obtener precio base con multiplicador por país
              let precioBase = rowValues.customPriceActive
                ? rowValues.customPrice
                : rowValues.servicio && rowValues.planServicio
                  ? CalcularPrecioPais({
                      precio: servicios
                        .find((e) => e.id === rowValues.servicio)
                        ?.preciosUnitarios.find(
                          (ev2) => ev2.plan.id === rowValues.planServicio
                        )?.precio || 0,
                      multiplicador: ObtenerMultiplicador({
                        pais: data?.cotizacion?.cliente?.pais || data?.cotizacion?.lead?.country,
                        paises: paises
                      })
                    })
                  : 0;

              // 2. Calcular subtotal (precio base * cantidad)
              let subtotal = precioBase;

              // 3. Aplicar descuento
              if (rowValues.tipoDescuento === "Porcentaje") {
                subtotal = subtotal * (1 - (rowValues.montoDescuento / 100));
              } else if (rowValues.tipoDescuento === "Fijo") {
                subtotal = subtotal - rowValues.montoDescuento;
              }

              // 4. Calcular IGV si aplica
              let igv = 0;
              if (rowValues.igv === "si") {
                igv = subtotal * 0.18;
              }

              // 5. Calcular precio total (subtotal + IGV)
              const precioTotal = subtotal + igv;

              return precioTotal?.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            })()}
          </span>
        </td>

        {/* Precio venta total */}
        <td className="px-6 py-4">
          <span className="text-xs">
            {(() => {
              // 1. Obtener precio base con multiplicador por país
              let precioBase = rowValues.customPriceActive
                ? rowValues.customPrice
                : rowValues.servicio && rowValues.planServicio
                  ? CalcularPrecioPais({
                      precio: servicios
                        .find((e) => e.id === rowValues.servicio)
                        ?.preciosUnitarios.find(
                          (ev2) => ev2.plan.id === rowValues.planServicio
                        )?.precio || 0,
                      multiplicador: ObtenerMultiplicador({
                        pais: data?.cotizacion?.cliente?.pais || data?.cotizacion?.lead?.country,
                        paises: paises
                      })
                    })
                  : 0;

              // 2. Calcular subtotal (precio base * cantidad)
              let subtotal = precioBase * rowValues.numeroItems;

              // 3. Aplicar descuento
              if (rowValues.tipoDescuento === "Porcentaje") {
                subtotal = subtotal * (1 - (rowValues.montoDescuento / 100));
              } else if (rowValues.tipoDescuento === "Fijo") {
                subtotal = subtotal - (rowValues.montoDescuento * rowValues.numeroItems);
              }

              // 4. Calcular IGV si aplica
              let igv = 0;
              if (rowValues.igv === "si") {
                igv = subtotal * 0.18;
              }

              // 5. Calcular precio total (subtotal + IGV)
              const precioTotal = subtotal + igv;

              return precioTotal?.toLocaleString("es-PE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            })()}
          </span>
        </td>      
        
      </tr>
    </>
  );
};

export default React.memo(ItemRowServicioCotizacion);
